import React from 'react'
import createReactClass from 'create-react-class'
import PropTypes from 'prop-types'

import { BranchMixin, SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { Input, FormComponentMixin } from 'legacy/libs/react-form-tools'
import EditableRegion from 'legacy/apps/region/components/editable-gis-region'
import Tab from 'legacy/libs/components/tab'
import TabLink from 'legacy/libs/components/tab-link'
import regionApi from 'legacy/api/region'
import BaobabPropTypes from 'legacy/libs/baobab-prop-types'

import { withGettext } from 'lib/gettext'
import { TabNav } from 'common'
import s from './search-regions-input.module.scss'

const SearchRegionsInput = withGettext(
  createReactClass({
    displayName: 'SearchRegionInput',
    mixins: [SchemaBranchMixin],

    propTypes: {
      gettext: PropTypes.func.isRequired,
      tree: PropTypes.oneOfType([
        BaobabPropTypes.baobab,
        BaobabPropTypes.cursor,
      ]).isRequired,
    },

    schema: {
      isLoaded: false,
      isLoading: false,
      data: [],
      extra: {
        currentTab: 'name',
        searchRegionWkt: null,
        searchRegionName: null,
      },
    },

    UNSAFE_componentWillMount() {
      this.resetResults()
      this.cursors.extra.set('currentTab', 'name')
    },

    componentDidMount() {
      this.cursors.extra.select('currentTab').on('update', this.onTabChange)
    },

    componentWillUnmount() {
      this.cursors.extra.select('currentTab').off('update', this.onTabChange)
    },

    onTabChange({ data }) {
      if (data.currentData === data.previousData) {
        return
      }

      this.resetSearch()
      this.resetResults()
    },

    setValue(value) {
      this.props.tree.merge(value)
    },

    resetSearch() {
      this.cursors.extra.set('searchRegionWkt', null)
      this.cursors.extra.set('searchRegionName', null)
    },

    resetResults() {
      this.setValue({ data: [], isLoaded: false, isLoading: false })
    },

    onInputSync(value) {
      if (value.length < 3) {
        this.resetResults()
        return
      }

      this.setValue({ data: [], isLoaded: false, isLoading: true })

      regionApi.getCompletedList({ search: value }).then((data) =>
        this.setValue({
          data,
          isLoaded: true,
          isLoading: false,
        })
      )
    },

    onSearchRegionSync(value) {
      this.setValue({ data: [], isLoaded: false, isLoading: true })

      regionApi.getIntersectsList({ wkt: value }).then((data) =>
        this.setValue({
          data,
          isLoaded: true,
          isLoading: false,
        })
      )
    },

    onClearMapClick() {
      this.resetSearch()
      this.resetResults()
    },

    renderSearchByName() {
      return (
        <div>
          <Input
            cursor={this.cursors.extra.select('searchRegionName')}
            className={s.search__input}
            onSync={this.onInputSync}
            placeholder={this.props.gettext(
              'Filter existing regions by keyword...'
            )}
            autoFocus
          />
        </div>
      )
    },

    renderSearchByDrawing() {
      return (
        <div>
          <EditableRegion
            className={s.container}
            cursor={this.cursors.extra.select('searchRegionWkt')}
            autoFitMap={false}
            drawable={!this.state.extra.searchRegionWkt}
            onSync={this.onSearchRegionSync}
            onClearClick={this.onClearMapClick}
            mapConfig={{
              scrollwheel: false,
              zoomControl: true,
            }}
            hideAdministrativeLines
          />
        </div>
      )
    },

    render() {
      const { gettext } = this.props
      const currentTabCursor = this.cursors.extra.select('currentTab')

      return (
        <div className={s.content}>
          <div className={s.container}>
            <TabNav>
              <span className="uppercase text-gray-drh">
                {gettext('Search by')}
              </span>

              <TabLink name="name" cursor={currentTabCursor}>
                {gettext('Region name')}
              </TabLink>

              <TabLink name="drawing" cursor={currentTabCursor}>
                {gettext('Certain area on the map')}
              </TabLink>
            </TabNav>
          </div>

          <div>
            <Tab name="name" cursor={currentTabCursor}>
              <div className={s.container}>{this.renderSearchByName()}</div>
            </Tab>

            <Tab name="drawing" cursor={currentTabCursor}>
              {this.renderSearchByDrawing()}
            </Tab>
          </div>
        </div>
      )
    },
  })
)

export default createReactClass({
  displayName: 'SearchRegionsInputWrapper',

  mixins: [BranchMixin, FormComponentMixin],

  cursors(props, context) {
    return {
      value: this.getCursor(props, context),
    }
  },

  render() {
    return <SearchRegionsInput tree={this.cursors.value} />
  },
})
